export type VoiceAiEnablementSources = {
  persistedEnabled: boolean;
  launchDarklyEnabled: boolean;
};

export function isVoiceAiEffectivelyEnabled({
  persistedEnabled,
  launchDarklyEnabled,
}: VoiceAiEnablementSources): boolean {
  return persistedEnabled || launchDarklyEnabled;
}
